
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60556_6307)"}},[_c('path',{attrs:{"d":"M14.417 3.333H1.583m4.667 3.5V11.5m3.5-4.667V11.5m3.5-8.167v11.084a.583.583 0 01-.583.583H3.333a.583.583 0 01-.583-.583V3.333m8.167 0V2.167A1.167 1.167 0 009.75 1h-3.5a1.167 1.167 0 00-1.167 1.167v1.166","stroke":"#4A4A4A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60556_6307"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    